// extracted by mini-css-extract-plugin
module.exports = {"page":"ModalPage_page__ekLeJ","fixedHeight":"ModalPage_fixedHeight__eVASL","fullPage":"ModalPage_fullPage__8TlDB"};